import { render, staticRenderFns } from "./FormLoading.vue?vue&type=template&id=3f5f971e&"
import script from "./FormLoading.vue?vue&type=script&lang=ts&"
export * from "./FormLoading.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports